/* WICK 10/10/2026 - Unidades por ticket: envio gratis, pegatinas de regalo, carrusel de complementos, pagos y "Completa el look" */
(function () {
  var C = window.WICK_UPT;
  if (!C) return;

  var T = {
    es: { left: 'Te faltan {a} para el envío gratis', ok: '¡Tienes envío gratis!', giftLeft: 'Añade {n} más y te regalamos pegatinas WICK', one: '1 prenda', many: '{n} prendas', giftOk: 'Pegatinas WICK de regalo incluidas', free: 'GRATIS', like: 'Podría gustarte', look: 'Completa el look' },
    en: { left: "You're {a} away from free shipping", ok: "You've unlocked free shipping!", giftLeft: 'Add {n} and get free WICK stickers', one: '1 more item', many: '{n} more items', giftOk: 'Free WICK stickers included', free: 'FREE', like: 'You may also like', look: 'Complete the look' },
    de: { left: 'Noch {a} bis zum kostenlosen Versand', ok: 'Du erhältst kostenlosen Versand!', giftLeft: 'Noch {n} – dann gibt es gratis WICK-Sticker', one: '1 Artikel', many: '{n} Artikel', giftOk: 'Gratis WICK-Sticker inklusive', free: 'GRATIS', like: 'Das könnte dir gefallen', look: 'Vervollständige den Look' },
    ja: { left: 'あと{a}で送料無料', ok: '送料無料になりました！', giftLeft: 'あと{n}追加でWICKステッカーをプレゼント', one: '1点', many: '{n}点', giftOk: 'WICKステッカーをプレゼント中', free: '無料', like: 'こちらもおすすめ', look: 'コーディネートを完成させる' },
    ko: { left: '{a} 더 담으면 무료 배송', ok: '무료 배송이 적용되었습니다!', giftLeft: '{n} 더 담으면 WICK 스티커 증정', one: '1개', many: '{n}개', giftOk: 'WICK 스티커 무료 증정', free: '무료', like: '추천 상품', look: '룩 완성하기' },
    fr: { left: 'Plus que {a} pour la livraison gratuite', ok: 'Livraison gratuite débloquée !', giftLeft: 'Ajoute {n} et reçois des stickers WICK offerts', one: '1 article de plus', many: '{n} articles de plus', giftOk: 'Stickers WICK offerts inclus', free: 'OFFERT', like: 'Vous aimerez aussi', look: 'Complète le look' }
  };
  var L = T[(C.locale || 'en').split('-')[0]] || T.en;
  var root = (C.root || '/').replace(/\/$/, '');
  var cart = null, busy = false, upsellHTML = null, lookHTML = null;

  function money(v) {
    try {
      return new Intl.NumberFormat(C.locale || 'en', { style: 'currency', currency: C.currency, minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(Math.ceil(v));
    } catch (e) { return Math.ceil(v) + ' ' + C.currency; }
  }
  function isGift(i) { return i.variant_id == C.giftVariant || i.handle === C.giftHandle; }
  function units(c) { return c.items.reduce(function (n, i) { return isGift(i) ? n : n + i.quantity; }, 0); }
  function giftLine(c) { for (var k = 0; k < c.items.length; k++) if (isGift(c.items[k])) return c.items[k]; return null; }

  /* WICK 12/10/2026 - Importe del cupon en el carrito.
     El recuadro del cupon que pinta la app (bajo los puntos) calculaba su propio importe
     (p. ej. -€33.3) y no coincidia con el descuento real de Shopify (-€36,75).
     Se sustituye por el importe real que Shopify pinta en la linea de descuento del carrito,
     con el mismo formato (moneda y decimales de la tienda). No toca la linea nativa. */
  var WK_AMT = /[-−–]\s*(?:[€$£¥₩]\s*)?\d[\d.,]*(?:\s*(?:[€$£¥₩]|EUR|USD|GBP|JPY|KRW))?/g;
  function nativeDiscounts(scope) {
    var out = {};
    scope.querySelectorAll('.discounts__discount--end').forEach(function (li) {
      var t = li.textContent.replace(/\s+/g, ' ').trim();
      var m = t.match(/^(.*?)\s*\(\s*[-−]\s*(.+?)\s*\)$/);
      if (m && m[1]) out[m[1].trim().toLowerCase()] = '-' + m[2].trim();
    });
    return out;
  }
  function fixAppDiscounts(scope) {
    if (!scope) return;
    var amounts = nativeDiscounts(scope);
    var codes = Object.keys(amounts);
    if (!codes.length) return;
    var w = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT), n, texts = [];
    while ((n = w.nextNode())) texts.push(n);
    codes.forEach(function (code) {
      var good = amounts[code];
      texts.forEach(function (tn) {
        if ((tn.nodeValue || '').toLowerCase().indexOf(code) === -1) return;
        var el = tn.parentElement;
        if (!el || el.closest('.discounts')) return;
        var box = el;
        for (var k = 0; k < 4; k++) {
          WK_AMT.lastIndex = 0;
          if (WK_AMT.test(box.textContent)) break;
          if (!box.parentElement || box.parentElement === scope) return;
          box = box.parentElement;
        }
        if (box.querySelector('.discounts') || box.closest('.discounts')) return;
        var bw = document.createTreeWalker(box, NodeFilter.SHOW_TEXT), bn;
        while ((bn = bw.nextNode())) {
          var v = bn.nodeValue || '';
          var nv = v.replace(WK_AMT, function (a) { return a.trim() === good ? a : good; });
          if (nv !== v) bn.nodeValue = nv;
        }
      });
    });
  }

  function drawer() { return document.querySelector('cart-drawer'); }
  function sectionsParam() {
    var s = ['cart-icon-bubble'];
    if (drawer()) s.unshift('cart-drawer');
    if (document.getElementById('main-cart-items') || document.querySelector('cart-items')) {
      document.querySelectorAll('[id^="shopify-section-"][id*="__cart-items"],[id^="shopify-section-"][id*="__cart-footer"]').forEach(function (el) { s.push(el.id.replace('shopify-section-', '')); });
    }
    return s.join(',');
  }
  function applySections(resp, openIt) {
    if (!resp || !resp.sections) return;
    var d = drawer();
    if (d && resp.sections['cart-drawer']) {
      var nd = new DOMParser().parseFromString(resp.sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
      var cd = d.querySelector('#CartDrawer');
      if (nd && cd) {
        cd.innerHTML = nd.innerHTML;
        var inner = d.querySelector('.drawer__inner');
        if (inner) inner.classList.remove('is-empty');
        d.classList.remove('is-empty');
        var ov = d.querySelector('#CartDrawer-Overlay');
        if (ov && typeof d.close === 'function') ov.addEventListener('click', d.close.bind(d));
      }
      if (openIt && typeof d.open === 'function' && !d.classList.contains('active')) d.open();
    }
    Object.keys(resp.sections).forEach(function (id) {
      if (id === 'cart-drawer') return;
      var el = document.getElementById('shopify-section-' + id);
      if (!el || !resp.sections[id]) return;
      var doc = new DOMParser().parseFromString(resp.sections[id], 'text/html');
      var inner = doc.getElementById('shopify-section-' + id) || doc.querySelector('.shopify-section');
      if (inner) el.innerHTML = inner.innerHTML;
    });
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
  }
  function addVariant(id, btn) {
    if (btn) btn.classList.add('is-loading');
    return post(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', { items: [{ id: Number(id), quantity: 1 }], sections: sectionsParam(), sections_url: window.location.pathname })
      .then(function (r) {
        if (btn) btn.classList.remove('is-loading');
        if (r && r.status) { if (btn) { btn.classList.add('is-error'); setTimeout(function () { btn.classList.remove('is-error'); }, 1500); } return; }
        applySections(r, true);
        if (!drawer() && /\/cart\/?$/.test(location.pathname)) location.reload();
        refresh();
      })
      .catch(function () { if (btn) btn.classList.remove('is-loading'); });
  }

  function syncGift(c) {
    if (!C.giftVariant || busy) return Promise.resolve(false);
    var g = giftLine(c), n = units(c), change = null;
    if (n >= C.giftMin && !g) change = { add: true };
    else if (n < C.giftMin && g) change = { key: g.key, quantity: 0 };
    else if (g && g.quantity !== 1) change = { key: g.key, quantity: 1 };
    if (!change) return Promise.resolve(false);
    busy = true;
    var p = change.add
      ? post('/cart/add.js', { items: [{ id: C.giftVariant, quantity: 1 }], sections: sectionsParam(), sections_url: window.location.pathname })
      : post('/cart/change.js', { id: change.key, quantity: change.quantity, sections: sectionsParam(), sections_url: window.location.pathname });
    return p.then(function (r) {
      applySections(r);
      if (!drawer() && /\/cart\/?$/.test(location.pathname)) { location.reload(); return true; }
      return true;
    }).catch(function () { return false; }).then(function (v) { busy = false; return v; });
  }

  function barHTML(c) {
    var html = '';
    var th = C.thresholds[C.currency];
    if (th) {
      var total = c.total_price / 100;
      var pct = Math.min(100, Math.round(total / th * 100));
      var msg = total >= th ? L.ok : L.left.replace('{a}', money(th - total));
      html += '<div class="wk-bar"><p class="wk-bar__msg' + (total >= th ? ' is-ok' : '') + '">' + msg + '</p><div class="wk-bar__track"><span style="width:' + pct + '%"></span></div></div>';
    }
    if (C.giftVariant) {
      var n = units(c);
      if (n >= 1) html += '<p class="wk-gift' + (n >= C.giftMin ? ' is-ok' : '') + '">🎁 ' + (n >= C.giftMin ? L.giftOk : L.giftLeft.replace('{n}', (C.giftMin - n === 1 ? L.one : L.many.replace('{n}', C.giftMin - n)))) + '</p>';
    }
    return html;
  }

  function decorateGiftRows(scope) {
    scope.querySelectorAll('a[href*="' + C.giftHandle + '"]').forEach(function (a) {
      var row = a.closest('tr, .cart-item');
      if (!row || row.classList.contains('wk-gift-row')) return;
      row.classList.add('wk-gift-row');
      row.querySelectorAll('.price, .product-option').forEach(function (el) {
        if (/\d/.test(el.textContent) && !el.querySelector('dt')) el.textContent = L.free;
      });
    });
  }

  function cardsFor(c) {
    if (!upsellHTML) return '';
    var doc = new DOMParser().parseFromString(upsellHTML, 'text/html');
    var inCart = {};
    c.items.forEach(function (i) { inCart[i.product_id] = 1; });
    var out = '';
    doc.querySelectorAll('.wk-card').forEach(function (card) {
      if (!inCart[card.getAttribute('data-product-id')]) out += card.outerHTML;
    });
    return out;
  }
  function paymentsHTML() {
    if (!upsellHTML) return '';
    var doc = new DOMParser().parseFromString(upsellHTML, 'text/html');
    var ul = doc.querySelector('.wk-payments');
    return ul ? ul.outerHTML : '';
  }

  function render() {
    if (!cart) return;
    var d = drawer();
    if (d && cart.item_count > 0) {
      var inner = d.querySelector('.drawer__inner');
      var header = d.querySelector('.drawer__header');
      if (inner && header) {
        var top = inner.querySelector('.wk-top');
        if (!top) { top = document.createElement('div'); top.className = 'wk-top'; header.insertAdjacentElement('afterend', top); }
        var b = barHTML(cart);
        if (top._wk !== b) { top.innerHTML = b; top._wk = b; }

        var items = inner.querySelector('cart-drawer-items');
        var up = inner.querySelector('.wk-upsell');
        var cards = cardsFor(cart);
        if (cards) {
          if (!up) { up = document.createElement('div'); up.className = 'wk-upsell'; if (items) items.insertAdjacentElement('afterend', up); }
          var uh = '<p class="wk-upsell__title">' + L.like + '</p><div class="wk-upsell__row">' + cards + '</div>';
          if (up._wk !== uh) { up.innerHTML = uh; up._wk = uh; }
        } else if (up) { up.remove(); }

        var ctas = inner.querySelector('.cart__ctas');
        if (ctas && !inner.querySelector('.wk-pay')) {
          var ph = paymentsHTML();
          if (ph) { var pay = document.createElement('div'); pay.className = 'wk-pay'; pay.innerHTML = ph; ctas.insertAdjacentElement('afterend', pay); }
        }
        decorateGiftRows(inner);
        fixAppDiscounts(inner);
      }
    }
    var page = document.querySelector('cart-items');
    if (page && !page.closest('cart-drawer') && cart.item_count > 0) {
      var ptop = document.querySelector('.wk-top--page');
      if (!ptop) { ptop = document.createElement('div'); ptop.className = 'wk-top wk-top--page'; page.insertAdjacentElement('beforebegin', ptop); }
      var pb = barHTML(cart);
      if (ptop._wk !== pb) { ptop.innerHTML = pb; ptop._wk = pb; }
      decorateGiftRows(page);
      fixAppDiscounts(document.querySelector('main') || document.body);
    }
  }

  function refresh() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      cart = c;
      return syncGift(c).then(function (changed) {
        if (changed) return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c2) { cart = c2; render(); });
        render();
      });
    }).catch(function () {});
  }

  var t;
  function schedule() { clearTimeout(t); t = setTimeout(refresh, 150); }

  var of = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = of.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url) && !busy) p.then(function () { schedule(); });
    return p;
  };

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wk-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    addVariant(btn.getAttribute('data-wk-add'), btn);
  });

  function loadUpsell() {
    return fetch(root + '/?section_id=wick-cart-upsell').then(function (r) { return r.text(); }).then(function (h) { upsellHTML = h; }).catch(function () {});
  }

  function loadLook() {
    if (C.pageType !== 'product' || !C.productHandle) return;
    fetch(root + '/products/' + C.productHandle + '?section_id=wick-complete-look').then(function (r) { return r.text(); }).then(function (h) {
      var doc = new DOMParser().parseFromString(h, 'text/html');
      var looks = doc.querySelectorAll('.wk-look');
      if (!looks.length) return;
      var target = document.querySelector('.product__info-container product-form, .product__info-container .product-form__buttons');
      var box = document.createElement('div');
      box.className = 'wk-look-box';
      var html = '<p class="wk-look-box__title">' + L.look + '</p>';
      looks.forEach(function (l) { html += l.outerHTML; });
      box.innerHTML = html;
      if (target) target.insertAdjacentElement('afterend', box);
      else { var info = document.querySelector('.product__info-container'); if (info) info.appendChild(box); }
    }).catch(function () {});
  }

  function start() {
    var d = drawer();
    if (d) new MutationObserver(function () { clearTimeout(window.__wkR); window.__wkR = setTimeout(render, 40); }).observe(d, { childList: true, subtree: true, characterData: true });
    loadUpsell().then(refresh);
    loadLook();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
